module.exports = __webpack_public_path__ + "static/img/cert11.e30b94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert11.png
// module id = grkJ
// module chunks = 52